import LicenceForm from "./licenceForm";

const LicenceAddDialog = () => {
  return (
    <>
      <LicenceForm></LicenceForm>
    </>
  );
};

export default LicenceAddDialog;
